var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "fixBottom", staticClass: "popup px-16 pt-24 p-md-24 p-lg-56" },
    [
      _c("div", {
        staticClass: "close",
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      }),
      _vm._v(" "),
      _c("h2", { staticClass: "mb-16 mb-md-32" }, [_vm._v("Locatie")]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-32" }, [
        _vm._v("Kies een optie om verder te gaan.")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex align-items-center format-row mb-32" }, [
        _c(
          "a",
          {
            staticClass: "mr-24",
            class: {
              active: _vm.format === "WORDPRESS",
              "pl-0": _vm.format !== "WORDPRESS"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.setFormat("WORDPRESS")
              }
            }
          },
          [_vm._v("Inspirerende locaties")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            class: { active: _vm.format === "GOOGLE_MAPS" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.setFormat("GOOGLE_MAPS")
              }
            }
          },
          [_vm._v("Eigen locatie")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-32" },
        [
          _c("ValidationObserver", {
            ref: "observer",
            attrs: { tag: "div", slim: true },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var invalid = ref.invalid
                  var errors = ref.errors
                  return [
                    _vm.format === "WORDPRESS"
                      ? [
                          _c("el-input", {
                            staticClass: "mb-24",
                            attrs: {
                              options: _vm.locations,
                              type: "select",
                              name: _vm.translations.practical_details.location,
                              rules: "required",
                              placeholder:
                                _vm.translations.practical_details
                                  .location_choose
                            },
                            model: {
                              value: _vm.location,
                              callback: function($$v) {
                                _vm.location = $$v
                              },
                              expression: "location"
                            }
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.format === "GOOGLE_MAPS"
                      ? [
                          _c(
                            "div",
                            { staticClass: "d-flex mb-8" },
                            [
                              _c("ValidationProvider", {
                                ref: "location",
                                staticClass: "w-100",
                                attrs: {
                                  vid: "location",
                                  name:
                                    _vm.translations.practical_details.location,
                                  rules: "required",
                                  tag: "div"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var classes = ref.classes
                                        return [
                                          _c("vue-google-autocomplete", {
                                            ref: "locationAutocomplete",
                                            class: classes,
                                            attrs: {
                                              id: "location",
                                              name: "location",
                                              types: "",
                                              placeholder:
                                                _vm.translations
                                                  .practical_details
                                                  .location_choose,
                                              country: ["be"]
                                            },
                                            on: {
                                              placechanged: _vm.getAddressData,
                                              blur: _vm.validateAddress,
                                              change: _vm.validateAddress
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              }),
                              _vm._v(" "),
                              _c("ValidationProvider", {
                                ref: "range",
                                attrs: {
                                  vid: "range",
                                  name:
                                    _vm.translations.practical_details
                                      .location_range,
                                  rules: "integer|min:1|max:300",
                                  tag: "div"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var classes = ref.classes
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.radius,
                                                expression: "radius"
                                              }
                                            ],
                                            staticClass: "ml-16",
                                            class: classes,
                                            attrs: {
                                              type: "number",
                                              id: "range",
                                              name:
                                                _vm.translations
                                                  .practical_details
                                                  .location_range,
                                              min: "1",
                                              max: "300",
                                              placeholder:
                                                _vm.translations
                                                  .practical_details
                                                  .location_range
                                            },
                                            domProps: { value: _vm.radius },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.radius = $event.target.value
                                              }
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "kilometers ml-24 font-weight-light"
                                },
                                [_vm._v("km")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          (errors.location != null &&
                            errors.location.length > 0) ||
                          (errors.range != null && errors.range.length > 0)
                            ? _c(
                                "span",
                                { staticClass: "error small d-block mb-24" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      errors.location[0] || errors.range[0]
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "popup-footer d-flex align-items-center" }, [
        _c("button", {
          staticClass: "btn btn-accent btn-sm-100 text-white",
          domProps: {
            innerHTML: _vm._s(_vm.translations.participant_amount_popup.select)
          },
          on: { click: _vm.submit }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }